import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import { convert, DisplayCurrentTime, DisplayTime, formatDate } from './../../utils/convertDate';
import Paginate from '../../utils/Paginate';
import DatePicker from 'react-date-picker';
import AuditServices from './../../services/AuditServices';


export default function CustomerAudit() {
    const [audit, setAudit] = useState([])
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [pageLength, setPageLength] = useState("")
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));

    const list = async () => {
        const resp = await AuditServices.listCustomerAudit(pageIndex, 10, search, fromm, too);
        setAudit([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount);
        setPageIndex(resp.data.pageIndex);
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages);
        setNextPage(resp.data.hasNextPage);
    }


    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };
    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        const resp = await AuditServices.listCustomerAudit(pageIndex, 10, search, convert(newDate), convert(toDate));
        setAudit([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount);
        setPageIndex(resp.data.pageIndex);
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages);
        setNextPage(resp.data.hasNextPage);

    }
    const exportCSV = async () => {
        const resp = await AuditServices.listCustomerAudit(search, fromm, too);
        window.open(resp.data);
    }

    const searchInvest = async (text) => {
             setSearch(text);

    }
    useEffect(() => {
        list();
    }, [pageIndex])
    return (
        <div>
            <Layout title='Customer Audit Logs' pageTag={'security'} current={'/customer/audit'}>
                <React.Fragment>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="mt-4 sm:mt-0 sm:ml-16 flex justify-end">
                            <button
                                type="button"
                                onClick={exportCSV}
                                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                        </div>
                        <div className="sm:flex sm:items-center mt-10">

                            <div className="sm:flex-auto flex">
                                                      
                                <div className=" relative rounded-md shadow-sm ml-3">
                                    <p className='text-sm leading-3 text-gray-500'>From</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                    </div>
                                </div>
                                <div className=" relative rounded-md shadow-sm ml-3">
                                    <p className='text-sm leading-3 text-gray-500'>To</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                    </div>
                                </div>
                                <div className='flex ml-3'>
                                    <div className="mt-5 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            onChange={(e) => searchInvest(e.target.value)}
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                            placeholder="Search investments"
                                        />
                                        <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                            <div className='tooltip'>
                                                <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                <span className="tooltiptext"> <p>Search by source account number,investment category,investment type, surname and first name</p></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                                <div className='mt-5 ml-4'>
                                    <button
                                        onClick={range}
                                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                </div>
                            </div>
                        </div>
                        {audit.length === 0 ? (
                            <div className=" mt-8"> No data available for these dates to show. </div>
                        ) :
                        <>
                        <div className="mt-8 flex flex-col">
                            <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                    <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="min-w-[9rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                        Username
                                                    </th>
                                                    <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                        Action
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                        Ip Address
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                        Description
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                        Date Created
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                    Time Created
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                        <span className="sr-only">Edit</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {audit.map((person, i) => (
                                                    <tr key={i} className="bg-gray-50">
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.userName}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.action}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.ipAddress}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.description}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{formatDate(person.dateCreated)}</td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{DisplayTime(person.dateCreated)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                    </>
                        }
                   

                    </div>
                </React.Fragment>
            </Layout>


        </div>
    )
}